'use es6';

import * as ActionTypes from './ActionTypes';
import * as ecosystemClient from '../clients/ecosystemClient';
import * as qualityClient from '../clients/qualityClient';
import I18n from 'I18n';
const notificationsKey = 'marketplace-assets-ui.themes.details.reviews';
export const fetchReviewability = offeringId => dispatch => {
  dispatch({
    type: ActionTypes.REVIEWABILITY_REQUESTED
  });
  return ecosystemClient.fetchReviewability(offeringId).then(resp => {
    dispatch({
      type: ActionTypes.REVIEWABILITY_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.REVIEWABILITY_FAILED,
      payload: error
    });
  });
};
export const resetReviewabilityStatus = () => ({
  type: ActionTypes.REVIEWABILITY_RESET
});
export const submitReview = review => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_WRITE_REQUESTED
  });
  return ecosystemClient.writeReview(review).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.REVIEW_WRITE_FAILED,
      payload: error,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.write.error.titleText`),
          message: I18n.text(`${notificationsKey}.write.error.message`)
        }
      }
    });
  });
};
export const resetReviewSubmitted = () => ({
  type: ActionTypes.REVIEW_SUBMITTED_RESET
});
export const initializeReviewFilters = offeringId => ({
  type: ActionTypes.REVIEW_FILTERS_INITIALIZED,
  payload: {
    offeringId
  }
});
export const updateReviewFilters = (updates, reviewType = 'THEME') => ({
  type: ActionTypes.REVIEW_FILTERS_UPDATED,
  payload: {
    updates,
    reviewType
  }
});
export const fetchReviews = (queries, reviewType = 'THEME') => dispatch => {
  dispatch({
    type: ActionTypes.REVIEWS_LIST_REQUESTED
  });
  return ecosystemClient.fetchReviews(queries, reviewType).then(resp => {
    dispatch({
      type: ActionTypes.REVIEWS_LIST_RECEIVED,
      payload: Object.assign({}, resp, {
        reviewType
      })
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.REVIEWS_LIST_FAILED,
      payload: error
    });
  });
};
export const resetReviewsListStatus = () => ({
  type: ActionTypes.REVIEWS_LIST_RESET
});
export const fetchReviewStats = (offeringId, reviewType = 'THEME') => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_STATS_REQUESTED
  });
  return ecosystemClient.fetchReviewStats(offeringId, reviewType).then(resp => {
    dispatch({
      type: ActionTypes.REVIEW_STATS_RECEIVED,
      payload: resp
    });
  }).catch(error => {
    dispatch({
      type: ActionTypes.REVIEW_STATS_FAILED,
      payload: error
    });
  });
};
export const resetReviewStatsStatus = () => ({
  type: ActionTypes.REVIEW_STATS_RESET
});
export const toggleReviewHelpful = (reviewId, userId, isHelpful) => dispatch => {
  dispatch({
    type: ActionTypes.REVIEW_HELPFUL_REQUESTED
  });
  ecosystemClient.toggleHelpful(reviewId, isHelpful).then(() => {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_RECEIVED,
      payload: {
        reviewId,
        userId,
        isHelpful
      }
    });
  }).catch(err => {
    dispatch({
      type: ActionTypes.REVIEW_HELPFUL_FAILED,
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.helpful.error.titleText`),
          message: I18n.text(`${notificationsKey}.helpful.error.message`)
        }
      }
    });
  });
};

const getReportErrorKey = err => {
  const alreadyReported = err.responseJSON && err.responseJSON.message && err.responseJSON.message.includes('already reported');
  return alreadyReported ? 'duplicate_error' : 'error';
};

const genericReportAction = (actionPrefix, apiMethod, data) => dispatch => {
  dispatch({
    type: ActionTypes[`${actionPrefix}_REQUESTED`]
  });
  return apiMethod(data).then(resp => {
    dispatch({
      type: ActionTypes[`${actionPrefix}_RECEIVED`],
      payload: resp,
      meta: {
        notification: {
          titleText: I18n.text(`${notificationsKey}.report.success.titleText`),
          message: I18n.text(`${notificationsKey}.report.success.message`)
        }
      }
    });
  }).catch(err => {
    const errorKey = getReportErrorKey(err);
    dispatch({
      type: ActionTypes[`${actionPrefix}_FAILED`],
      payload: err,
      meta: {
        notification: {
          type: 'danger',
          titleText: I18n.text(`${notificationsKey}.report.${errorKey}.titleText`),
          message: I18n.text(`${notificationsKey}.report.${errorKey}.message`)
        }
      }
    });
  });
};

export const reportReview = data => dispatch => {
  dispatch(genericReportAction('REVIEW_REPORT', qualityClient.reportReview, data));
};
export const reportReply = data => dispatch => {
  dispatch(genericReportAction('REVIEW_REPLY_REPORT', qualityClient.reportReply, data));
};